@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.errorCard {
  min-height: 146px;

  &.noHeight {
    min-height: unset;
  }

  .row + .row {
    margin-top: 14px;
  }
  .body, .footer {
    padding-left: 21px;
  }

  .errorStatus {
    width: 14px;
    height: 14px;
    margin-right: 7px;
    border-radius: 50%;

    &.error {
      background: v.$gradient-error;
    }
    &.not-defined {
      background: v.$gradient-undefined;
    }
  }
  .containerId {
    @include t.text(14px, 18px, 600);
    text-transform: uppercase;
    color: v.$palette-gray-400;
  }

  .errorText {
    @include t.text(14px, 22px, 600);
    color: v.$palette-gray-900;
  }

  .deleteButton {
    margin-left: 8px;
  }
}

.alignEnd {
  align-items: end;
}

.buttonsContainer {
  display: flex;
  width: 100%;
  position: relative;
}

.followButton {
  margin-left: auto;
}